import React from "react";
import TableCell from "@material-ui/core/TableCell";
import { formatCurrencyTwoDecimal, formatDate } from "components/Global/Metric/formattersv2";
import { InputAdornment, IconButton } from "@material-ui/core";
import RefreshOutlinedIcon from "@material-ui/icons/Cached";
import { MoneyInput } from "components/Global/FormikMaterial";

const EMPTY_VALUE = "--";

export const HedgeEscrowLedgerColumns = getCapCostInflator => ({
  date: {
    id: "date",
    label: "Date",
    numeric: false,
    isString: false,
    isDateField: true,
    dataField: "date",
    Cell: ({ data }) => (<TableCell>{data.date ? formatDate(data.date) : EMPTY_VALUE}</TableCell>)
  },
  capCostMarket: {
    id: "capCostMarket",
    label: "Cap Cost",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "capCostMarket",
    Cell: ({ data, isEditable, onSave, index }) => (
      <TableCell>
        {
          isEditable(data) ? (
            <MoneyInput
              name={`hedgeEscrows.${index}.capCostMarket`}
              value={data.capCostMarket}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => onSave(data)} edge="end">
                    <RefreshOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          ) :
            data.capCostMarket ? formatCurrencyTwoDecimal(data.capCostMarket) : EMPTY_VALUE
        }
      </TableCell>
    )
  },
  capCostInflated: {
    id: "capCostInflated",
    label: `Cap Cost ${getCapCostInflator()}`,
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "capCostMarket",
    Cell: ({ data }) => (
      <TableCell>
        {data.capCostInflated ? formatCurrencyTwoDecimal(data.capCostInflated) : EMPTY_VALUE}
      </TableCell>
    )
  },
  monthlyEscrow: {
    id: "monthlyEscrow",
    label: "Monthly Escrow",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "capCostMarket",
    Cell: ({ data }) => (
      <TableCell>
        {data.monthlyEscrow ? formatCurrencyTwoDecimal(data.monthlyEscrow) : EMPTY_VALUE}
      </TableCell>
    )
  },
  disbursement: {
    id: "disbursement",
    label: "Disbursement",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "disbursement",
    Cell: ({ data }) => (
      <TableCell>
        {data.disbursement ? formatCurrencyTwoDecimal(data.disbursement) : EMPTY_VALUE}
      </TableCell>
    )
  },
  escrowBalance: {
    id: "escrowBalance",
    label: "Escrow Balance",
    numeric: false,
    isString: true,
    isDateField: false,
    dataField: "escrowBalance",
    Cell: ({ data }) => (
      <TableCell>
        {data.escrowBalance ? formatCurrencyTwoDecimal(data.escrowBalance) : EMPTY_VALUE}
      </TableCell>
    )
  }
});
